import React from 'react';
import ConvertedPrice from '../styled/ConvertedPrice';

interface ApproximatedConvertedPriceProps {
  formattedPrice?: string;
}

const ApproximatedConvertedPrice: React.FC<ApproximatedConvertedPriceProps> = ({ formattedPrice }) =>
  formattedPrice ? <ConvertedPrice data-cy="price-approx-../../">Approx. {formattedPrice}</ConvertedPrice> : null;
export default ApproximatedConvertedPrice;
